import "./RemoveCompletedItems.scss";
import { useTranslation } from "react-i18next";

function RemoveCompletedItems({
  cancelRemoveCompletedItems,
  removeCompletedItems,
  completedCount,
}) {
  const { t } = useTranslation();
  return (
    <div className="remove-completed-items-content">
      <div className="modal-title">
        <div>{t("lists.modals.removeCompleted.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("lists.modals.removeCompleted.message", { count: completedCount })}</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveCompletedItems}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeCompletedItems}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveCompletedItems;
